import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue'),
    meta: {
      title: 'Inicio',
    },
  },
  // auth routes
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/auth/index.vue'),
    children: [
      {
        path: 'confirmsession',
        name: 'confirmsession',
        component: () => import('../views/auth/confirmsession.vue'),
        meta: {
          title: 'Verificando sesión',
        },
      },
    ],
  },
  // app
  {
    path: '/app',
    name: 'app',
    component: () => import('../views/app/index.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'app-home',
        redirect: '/app/patients',
      },
      // patients
      {
        path: 'patients',
        name: 'patients',
        component: () => import('../views/app/patients/index.vue'),
        children: [
          {
            path: '',
            name: 'patients-list',
            component: () => import('../views/app/patients/list.vue'),
            meta: {
              permissions: ['patients/find'],
            },
          },
          {
            path: 'filter',
            name: 'patients-filter',
            component: () => import('../views/app/patients/filter.vue'),
            meta: {
              permissions: ['patients/find'],
            },
          },
          {
            path: 'new',
            name: 'patients-new',
            component: () => import('../views/app/patients/new.vue'),
            meta: {
              permissions: ['patients/register'],
            },
          },
          {
            path: ':id',
            name: 'patients-detail',
            component: () => import('../views/app/patients/detail.vue'),
            meta: {
              permissions: ['patients/update'],
            },
          },
          {
            path: 'register-appointment/:id',
            name: 'patients-register-appointment',
            component: () => import('../views/app/patients/register-appointment.vue'),
            meta: {
              permissions: ['medical-consultations/add/{id}'],
            },
          },
          {
            path: 'medical-consultations/:id',
            name: 'patients-medical-consultations',
            component: () => import('../views/app/patients/medical-consultations.vue'),
            meta: {
              permissions: ['medical-consultations/getbypatientid/{id}'],
            },
          },
        ],
      },
      // calendar
      {
        name: 'calendar',
        path: 'calendar',
        component: () => import('../views/app/calendar/index.vue'),
        children: [
          {
            name: 'calendar-list',
            path: '',
            redirect: '/app/calendar/day',
          },
          {
            name: 'calendar-addevent',
            path: 'addevent',
            component: () => import('../views/app/calendar/addevent.vue'),
            meta: {
              permissions: ['appointments/add'],
            },
          },
          {
            name: 'calendar-day',
            path: 'day',
            component: () => import('../views/app/calendar/day.vue'),
            meta: {
              permissions: ['appointments/get'],
            },
          },
          {
            name: 'calendar-event',
            path: 'event/:id',
            component: () => import('../views/app/calendar/event.vue'),
            meta: {
              permissions: ['appointments/get/{id}'],
            },
          },
        ],
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const title = to.meta.title as string;
  document.title = title ? `${title} - digi-care` : 'digi-care';
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const token = localStorage.getItem('token');
  const isAuth = Boolean(token);
  if (requiresAuth && !isAuth) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    const { VUE_APP_DIGI_USERS_F } = process.env;
    window.location.href = `${VUE_APP_DIGI_USERS_F}/auth/login?app=care`;
    return;
  }

  next();
});

export default router;
